function lockBodyScroll() {
  document.body.style.overflow = "hidden";
}

function unlockBodyScroll() {
  document.body.style.overflow = "";
}

function showgallery(id) {
  lockBodyScroll();
  document.getElementById(id).style.display = "flex";
  document.getElementById("gallery").style.display = "block";
  document.getElementById("closebutton").style.display = "block";
}

function closegallery() {
  unlockBodyScroll();
  document.getElementById("gallery").style.display = "none";
  document.getElementById("closebutton").style.display = "none";
  document.getElementById("photo-gallery").style.display = "none";
}
